export default __webpack_public_path__ + "static/building_pin-selected.5ead3eb62ca664e446ca3c4a8d226319.png";